module.exports = Snap;


/*****************
 ** WEBPACK FOOTER
 ** external "Snap"
 ** module id = 37
 ** module chunks = 0
 **/